module.exports = __webpack_public_path__ + "static/media/tab-img-1.9a4e39d2.jpg";